export default __webpack_public_path__ + "static/media/change-profile-icon.89dfa1ba.svg";